import { Suspense, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import Sidebar from "../components/admin/Sidebar";
import { AdminAuthProvider, useAdminAuth } from "../context/AdminAuthContext";
import LoginModal from "../components/admin/auth/LoginModal";
import { subscribeToBookings } from "../components/booking/firebase/bookings";

const AdminAuthButton = () => {
  const { isAuthed, setShowLogin, logout } = useAdminAuth();
  return isAuthed ? (
    <button
      type="button"
      onClick={logout}
      className="px-4 py-2 border border-white/10 hover:border-red-700/40 text-white/40 hover:text-red-500/80 text-[10px] uppercase tracking-widest font-bold transition-colors duration-200"
    >
      Log Out
    </button>
  ) : (
    <button
      type="button"
      onClick={() => setShowLogin(true)}
      className="px-4 py-2 border border-white/10 hover:border-red-700/40 text-white/40 hover:text-red-500/80 text-[10px] uppercase tracking-widest font-bold transition-colors duration-200"
    >
      Login
    </button>
  );
};

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  // Open the (shared) bookings listener as soon as the admin area loads, so
  // Approved / Manage Bookings and the Dashboard already have data when opened.
  useEffect(() => subscribeToBookings(() => {}), []);

  return (
    <AdminAuthProvider>
      <div className="flex w-full min-h-screen bg-black">
        <Sidebar
          collapsed={collapsed}
          onToggleCollapsed={() => setCollapsed((prev) => !prev)}
          mobileOpen={mobileOpen}
          onCloseMobile={() => setMobileOpen(false)}
        />
        <main className="flex-1 w-full min-w-0">
          <div className="flex items-center justify-between px-4 md:px-12 pt-6">
            <button
              type="button"
              onClick={() => setMobileOpen(true)}
              aria-label="Open menu"
              className="md:hidden p-2 text-white/60 hover:text-white border border-white/10 hover:border-red-700/40 transition-colors duration-200"
            >
              <Menu size={20} />
            </button>
            <div className="flex-1 flex justify-end">
              <AdminAuthButton />
            </div>
          </div>
          <Suspense fallback={<div className="p-12 text-white/30 text-sm">Loading…</div>}>
            <Outlet />
          </Suspense>
        </main>
      </div>
      <LoginModal />
    </AdminAuthProvider>
  );
};

export default AdminLayout;